module.exports = __webpack_public_path__ + "static/media/am_enter-new-accounts.4508d691.md";


//////////////////
// WEBPACK FOOTER
// ./src/docs/am_enter-new-accounts.md
// module id = 1087
// module chunks = 0